import { SorterDirection } from '@common/services';
import React from 'react';

export const SortingIcon = ({ direction, width, height }: SortingIconProps) => {
  return (
    <svg width={width ?? 20} height={height ?? 20} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">

      <path d="M 6.4987 2 L 3.83203 4.66 H 5.83203 V 9.33333 H 7.16536 V 4.66 H 9.16536 L 6.4987 2"
            fill={direction === 'asc' ? '#5252BE' : '#A5A5F6'} />

      <path d="M 11.1654 11.34 V 6.66667 H 9.83203 V 11.34 H 7.83203 L 10.4987 14 L 13.1654 11.34 H 11.1654"
            fill={direction === 'desc' ? '#5252BE' : '#A5A5F6'} />
    </svg>
  );
};

interface SortingIconProps {
  direction: SorterDirection | null;
  width?: number;
  height?: number;
}